import * as types from './action-types';
import { errorHandler } from '../../../utils/errors';
import NotificationApi from '../../../api/NotificationApi';

export const getNotificationSettings = () => ({
	type: types.FETCH_NOTIFICATION_SETTING,
	payload: NotificationApi.fetchNotificationSettings()
});

export const setPortalSettings = data => ({
	type: types.SET_PORTAL_SETTINGS,
	payload: NotificationApi.setPortalNotification(data)
});



// WEBPACK FOOTER //
// ./src/features/notification/notification-settings/actions.js